import { Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import type { FC } from 'react';
import { useLocation } from 'react-location';
const TOSAdditionalInformation: FC<{ content: string; setAdditionalContent: (content: string) => void }> = ({ content, setAdditionalContent }) => {
  const router = useLocation();
  return (
    <div className="pb-5 px-4 xl:px-8">
      <Typography variant="h2" className="w-full text-3xl px-24 text-center pt-6 pb-8 font-bold border-tc-7  border-t">
        Additional Information
      </Typography>
      <div id="add" className="w-full md:w-10/12 md:m-auto ">
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}></div>
        <a href={`${router.current.pathname}${router.current.searchStr}#services`} className="font-bold my-4 block" onClick={() => setAdditionalContent('')}>
          Back To Main Content
        </a>
      </div>
    </div>
  );
};
export default TOSAdditionalInformation;
